import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';

interface Props {
  deliversToAddress: boolean;
}

export const TireOfferDeliveryCheckInfo = ({ deliversToAddress }: Props) => {
  if (deliversToAddress) {
    return <NoddiInfoBanner title={t`We deliver tire mounting services to your address`} variant='success' />;
  }
  return (
    <NoddiInfoBanner
      title={t`Unfortunately, we do not deliver mobile tire mounting services to your address.`}
      variant='error'
    />
  );
};
